import {
  DEPOSIT_FEE_SPREAD_RATE,
  RENT_CLUB_MEMBERSHIP_POINTS_RATE,
  RENT_CLUB_MEMBERSHIP_RATE,
} from "../../../../constants";

const MONTHS_PER_YEAR = 12;
const DEFAULT_RENT = 1000;

function formatPounds(amount: number): string {
  return `£${Math.round(amount).toLocaleString("en-GB")}`;
}

function formatRentInput(input: HTMLInputElement, preserveCaret: boolean): number {
  const rawValue = input.value;
  const digitsOnly = rawValue.replace(/[^\d]/g, "");
  const rentPerMonth = Number.parseInt(digitsOnly, 10) || 0;
  const formattedValue = digitsOnly ? rentPerMonth.toLocaleString("en-GB") : "";

  if (preserveCaret && document.activeElement === input) {
    const cursorPosition = input.selectionStart ?? rawValue.length;
    const digitsBeforeCursor = rawValue.slice(0, cursorPosition).replace(/[^\d]/g, "").length;
    input.value = formattedValue;

    if (digitsBeforeCursor === 0) {
      input.setSelectionRange(0, 0);
    } else {
      let nextCursorPosition = formattedValue.length;
      let seenDigits = 0;
      for (let i = 0; i < formattedValue.length; i++) {
        if (/\d/.test(formattedValue[i])) {
          seenDigits += 1;
        }
        if (seenDigits >= digitsBeforeCursor) {
          nextCursorPosition = i + 1;
          break;
        }
      }
      input.setSelectionRange(nextCursorPosition, nextCursorPosition);
    }
  } else {
    input.value = formattedValue;
  }

  return rentPerMonth;
}

function initCalculator() {
  const rentInput = document.getElementById("rent-input") as HTMLInputElement | null;
  const rentInput2 = document.getElementById("rent-input-2") as HTMLInputElement | null;
  const rewardsValueElement = document.getElementById("rewards-value");
  const feeSavingElement = document.getElementById("fee-saving");
  const netValueElement = document.getElementById("net-value");
  const membershipCostElement = document.getElementById("membership-cost");
  const depositSavingValueElement = document.getElementById("deposit-saving-value");
  const rewardsValueBreakdownElement = document.getElementById("rewards-value-breakdown");
  const membershipCostAnnualElement = document.getElementById("membership-cost-annual");
  const membershipCostDescriptionElement = document.getElementById("membership-cost-description");

  if (!rentInput || !rewardsValueElement || !feeSavingElement || !netValueElement || !membershipCostElement) {
    return;
  }

  const input = rentInput;
  const rewardsElement = rewardsValueElement;
  const feeElement = feeSavingElement;
  const netElement = netValueElement;
  const costElement = membershipCostElement;

  if (!input.value) {
    input.value = String(DEFAULT_RENT);
  }
  if (rentInput2 && !rentInput2.value) {
    rentInput2.value = input.value;
  }

  function syncTargetInputValue(formattedRent: string) {
    if (rentInput2) {
      rentInput2.value = formattedRent;
    }
  }

  function render(rentPerMonth: number) {
    const rentPerYear = rentPerMonth * MONTHS_PER_YEAR;

    const rewardsValue = RENT_CLUB_MEMBERSHIP_POINTS_RATE * rentPerYear;
    const depositFeeSaving = DEPOSIT_FEE_SPREAD_RATE * rentPerYear;
    const membershipCostAnnual = RENT_CLUB_MEMBERSHIP_RATE * rentPerYear;
    const membershipCostMonthly = membershipCostAnnual / MONTHS_PER_YEAR;
    const netValue = rewardsValue + depositFeeSaving - membershipCostAnnual;

    rewardsElement.textContent = `${formatPounds(rewardsValue)}/yr`;

    feeElement.innerHTML = `<span class="text-sm">up to </span><span class="text-2xl font-bold md:text-3xl">${formatPounds(depositFeeSaving)}</span>`;

    netElement.textContent = `+${formatPounds(netValue)}`;
    costElement.textContent = formatPounds(membershipCostMonthly);

    if (depositSavingValueElement) {
      depositSavingValueElement.textContent = `+${formatPounds(depositFeeSaving)}`;
    }
    if (rewardsValueBreakdownElement) {
      rewardsValueBreakdownElement.textContent = `+${formatPounds(rewardsValue)}/yr`;
    }
    if (membershipCostAnnualElement) {
      membershipCostAnnualElement.textContent = `-${formatPounds(membershipCostAnnual)}/yr`;
    }
    if (membershipCostDescriptionElement) {
      membershipCostDescriptionElement.textContent = `${formatPounds(membershipCostAnnual)} per year (${formatPounds(membershipCostMonthly)} per month)`;
    }
  }

  const initialRentPerMonth = formatRentInput(input, false);
  syncTargetInputValue(input.value);
  render(initialRentPerMonth);

  rentInput.addEventListener("input", () => {
    const rentPerMonth = formatRentInput(rentInput, true);
    syncTargetInputValue(rentInput.value);
    render(rentPerMonth);
  });

  if (rentInput2) {
    rentInput2.addEventListener("input", () => {
      const rentPerMonth = formatRentInput(rentInput2, true);
      input.value = rentInput2.value;
      render(rentPerMonth);
    });
  }
}

initCalculator();
